import { createRouter, createWebHistory } from "vue-router";
import store from '@/store/index';

const routes = [
    {
        path: '/',
        name: 'Main',
        component: () => import('@/views/Main.vue'),
        children: [
            {
                path: '/Home',
                name: 'Home',
                component: () => import('@/views/home')
            },
            {
                path: '/Examination',
                name: 'Examination',
                component: () => import('@/views/examination')
            },
            {
                path: '/ExaminationAb',
                name: 'ExaminationAb',
                component: () => import('@/views/examinationAb')
            },
            {
                path: '/UpperLimitAndRange',
                name: 'UpperLimitAndRange',
                component: () => import('@/views/upperLimitAndRange')
            },
            {
                path: '/Assignment', //赋分比例
                name: 'Assignment',
                component: () => import('@/views/assignment')
            },
            {
                path: '/EffectiveRanking',
                name: 'EffectiveRanking',
                component: () => import('@/views/effectiveRanking')
            },
            {
                path: '/AssignmentReference', //以分赋分
                name: 'AssignmentReference',
                component: () => import('@/views/assignmentReference')
            },
            {
                path: '/School',
                name: 'School',
                component: () => import('@/views/school')
            },
            {
                path: '/Grade',
                name: 'Grade',
                component: () => import('@/views/grade')
            },
            {
                path: '/Class',
                name: 'Class',
                component: () => import("@/views/class")
            },
            {
                path: '/ExaminationRecord',
                name: 'ExaminationRecord',
                component: () => import('@/views/examinationRecord')
            },
            {
                path: '/ExamRecordUpload', //考试记录分校上传
                name: 'ExamRecordUpload',
                component: () => import('@/views/examinationRecord/recordUpload.vue')
            },
            {
                path: '/RankingAllocation',
                name: 'RankingAllocation',
                component: () => import('@/views/rankingAllocation')
            },
            {
                path: '/StudentInformation',
                name: 'StudentInformation',
                component: () => import('@/views/studentInformation')
            },
            {
                path: '/AccountManagement',
                name: 'AccountManagement',
                component: () => import('@/views/accountManagement')
            },
            {
                path: '/SystemMenu',
                name: 'SystemMenu',
                component: () => import('@/views/menuItem')
            },
            {
                path: '/SubjectReachRate',
                name: 'SubjectReachRate',
                component: () => import('@/views/subjectReachRate')
            },
            {
                path: '/Role',
                name: 'Role',
                component: () => import('@/views/role')
            },
            {
                path: '/User',
                name: 'User',
                component: () => import('@/views/user')
            },
            {
                path: '/ExaminationSteps',
                name: 'ExaminationSteps',
                component: () => import('@/views/examinationSteps')
            },
            {
                path: '/ExaminationStepsAb',
                name: 'ExaminationStepsAb',
                component: () => import('@/views/examinationStepsAb')
            },
            {
                path: '/AssignPointsUploadAb',
                name: 'AssignPointsUploadAb',
                component: () => import('@/views/examinationStepsAb/assignPointsUpload.vue')
            },
            {
                path: '/UploadResultsAnalyse',
                name: 'UploadResultsAnalyse',
                component: () => import('@/views/examinationSteps/uploadAnalyze.vue')
            },
            {
                path: '/Teacher',
                name: 'Teacher',
                component: () => import('@/views/teacher')
            },
            {
                path: '/previousExamData',
                name: 'previousExamData',
                component: () => import('@/views/previousExamData')
            },
            {
                path: '/collateExamData',
                name: 'collateExamData',
                component: () => import('@/views/collateExamData')
            },
            {
                path: '/Log',
                name: 'Log',
                component: () => import('@/views/errorLog')
            },
            {
                path: '/Error',
                name: 'Error',
                component: () => import('@/views/error')
            }
        ]
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('@/views/login')
    },
    {
        path: '/examData',
        name: 'examData',
        component: () => import('@/views/examData')
    },
    {
        path: '/DownloadClassAnalyse',
        name: 'DownloadClassAnalyse',
        component: () => import('@/views/downloadClassAnalyse')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('getToken')
    const token = store.state.user.token
    if (token) {
        store.commit("getUserMenu");
        var menuList = store.state.user.userMenu;
        var usercomponents = getUserComponents(menuList);
        if (usercomponents.includes(to.name) || to.name.indexOf("Error") > -1) next();
        else {
            store.commit("clearToken");
            next({ name: 'Login' });
        }
    }
    else {
        if (to.name !== 'Login') next({ name: 'Login' });
        else next();
    }
})

const getUserComponents = function (menuList) {
    var components = [];
    store.commit('getUserInfo');
    components.push("Main")
    components.push("Home")
    if (menuList && menuList.length > 0) {
        menuList.forEach(item => {
            components.push(item.componentName);
            if (item.children && item.children.length > 0) {
                item.children.forEach(child => {
                    components.push(child.componentName)
                })
            }
        });
    }
    return components;
}

export default router;